const DividerIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        height="2"
        viewBox="0 0 150 2"
        fill="none"
      >
        <path d="M0 1H220" stroke="#0C3688" stroke-opacity="0.2" />
      </svg>
    </>
  );
};
export default DividerIcon;
